import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';
import OrderLayout from '../../../layout/order-layout';
import Loader from '../../../components/loader';
import { APP_API_URL } from '../../../utils';
import { isBrokenTileSaleValidated } from '../../../utils/broken-tile-sale';
import Invoice from './invoice';

export default function ValidateDamagedGood() {
  const { ref } = useParams();
  const user = useSelector((state) => state.auth.user);
  const isRole13 = Number(user?.personnels?.[0]?.poste_id) === 13;
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/damaged-goods/sales/${ref}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(response.data.sale);
    } catch (error) {
      Swal.fire({ icon: 'error', text: 'Impossible de charger la vente.' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (ref) fetchData();
  }, [ref]);

  const handleValidate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/damaged-goods/validate`, {
        sale_id: data.id,
        validated_by_id: user.id,
      }, { headers: { Authorization: `Bearer ${token}` } });
      await fetchData();
      Swal.fire({ icon: 'success', text: response.data.message, timer: 1800, showConfirmButton: false });
    } catch (error) {
      Swal.fire({ icon: 'error', text: error.response?.data?.error || 'Validation impossible.' });
      setLoading(false);
    }
  };

  const handleCancel = async () => {
    const result = await Swal.fire({
      title: 'Annuler la validation ?',
      text: 'Le stock cassé est rétabli et la facture normalisée est annulée.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, annuler',
    });
    if (!result.isConfirmed) return;
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${APP_API_URL}/damaged-goods/cancel`, {
        sale_id: data.id,
        user_id: user.id,
      }, { headers: { Authorization: `Bearer ${token}` } });
      await fetchData();
    } catch (error) {
      Swal.fire({ icon: 'error', text: error.response?.data?.error || 'Annulation impossible.' });
      setLoading(false);
    }
  };

  if (isLoading || !data) {
    return <Loader />;
  }

  const validated = isBrokenTileSaleValidated(data);

  return (
    <OrderLayout>
      <div className="mx-auto w-full max-w-6xl bg-white p-4">
        <div className="printable">
          <Invoice data={data} />
        </div>
        <div className="no-print d-flex gap-2 py-4">
          {!validated && !isRole13 && (
            <form onSubmit={handleValidate}>
              <button type="submit" className="duo-btn duo-btn--primary">Valider et facturer</button>
            </form>
          )}
          {validated && user?.role === 'Administrateur' && (
            <button type="button" className="duo-btn duo-btn--ghost" onClick={handleCancel}>Annuler la validation</button>
          )}
          <button type="button" className="duo-btn duo-btn--ghost" onClick={() => window.print()}>Imprimer</button>
        </div>
      </div>
    </OrderLayout>
  );
}
